import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../../../assets/styles/GlobalStyles';

const buttonVariants = {
  primary: css`
    background: ${colors.darkBlue};
    color: white;

    &:hover:not(:disabled) {
      background: #0a1a45;
      transform: translateY(-2px);
    }
  `,

  secondary: css`
    background: transparent;
    color: ${colors.darkBlue};
    border: 2px solid ${colors.darkBlue};

    &:hover:not(:disabled) {
      background: rgba(13, 35, 87, 0.05);
    }
  `,

  danger: css`
    background: #dc3545;
    color: white;

    &:hover:not(:disabled) {
      background: #c82333;
    }
  `,

  ghost: css`
    background: transparent;
    color: ${colors.darkBlue};

    &:hover:not(:disabled) {
      background: rgba(13, 35, 87, 0.05);
    }
  `
};

const buttonSizes = {
  small: css`
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  `,

  medium: css`
    padding: 0.8rem 1.5rem;
    font-size: 0.95rem;
  `,

  large: css`
    padding: 1rem 2rem;
    font-size: 1rem;
  `,

  full: css`
    width: 100%;
    padding: 1rem;
    font-size: 1rem;
  `
};

const StyledButton = styled.button`
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  ${props => buttonVariants[props.$variant || 'primary']}
  ${props => buttonSizes[props.$size || 'medium']}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  .icon-left {
    margin-right: 0.2rem;
  }

  .icon-right {
    margin-left: 0.2rem;
  }
`;

export const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  leftIcon,
  rightIcon,
  ...props
}) => {
  return (
    <StyledButton
      $variant={variant}
      $size={size}
      {...props}
    >
      {leftIcon && <span className="icon-left">{leftIcon}</span>}
      {children}
      {rightIcon && <span className="icon-right">{rightIcon}</span>}
    </StyledButton>
  );
};
